import { StateCreator } from 'zustand'
import TestimonialsService from 'service/TestimonialsService'
import { errorHandling } from 'store/utils/provider'
import { TestimonialStatusEnum } from 'common/enums/TestimonialEnum'

import { TestimonialsState } from './types'

export const createTestimonialsSlice: StateCreator<TestimonialsState, [], [], TestimonialsState> = (
  set,
  get,
) => ({
  testimonials: [],
  testimonialsLoaded: false,

  getTestimonials: async () => {
    if (get().testimonialsLoaded) {
      return
    }

    try {
      const response = await TestimonialsService.getTestimonials()

      const activeTestimonials = response.testimonials.filter(
        (testimonial) => testimonial.status === TestimonialStatusEnum.ACTIVE,
      )

      set(() => ({
        testimonials: activeTestimonials,
        testimonialsLoaded: true,
      }))
    } catch (error) {
      errorHandling(error as Error, 'TestimonialsService/getTestimonials')
    }
  },
})
